module.exports = __webpack_public_path__ + "img/yuanjing-white1.cb25b8fb.png";